import { Card } from '../components/ui'
import './Rules.css'

/**
 * The league's on-field rules, as a single reference page.
 */
export default function Rules() {
  return (
    <div className="stack">
      <header className="page-header">
        <div>
          <span className="eyebrow">Rules</span>
          <h1>How RTL is played</h1>
          <p>The league rules, as they stand.</p>
        </div>
      </header>

      <Card title="Regular season">
        <ul className="rules-list">
          <li>Play everyone in your conference once.</li>
          <li>
            Coin toss to determine P1, and roll for how many spins in the ROM “create match”.
          </li>
        </ul>
      </Card>

      <Card title="Playoffs">
        <ul className="rules-list">
          <li>
            Six teams from each conference make the playoffs.
            <ul>
              <li>The top two in each conference get byes.</li>
            </ul>
          </li>
          <li>
            Seeding when records are tied:
            <ul>
              <li>Two players: head-to-head.</li>
              <li>
                Three or more: point differential, unless one of them beat everyone else who is
                tied.
              </li>
              <li>
                If two players share the same point differential, those two go head-to-head.
              </li>
              <li>
                After a sweep or the best differential is pulled out, the remaining players start
                over — once two are left, it is head-to-head even if their differentials differ.
              </li>
            </ul>
          </li>
          <li>
            Playoff series are best of 3.
            <ul>
              <li>The higher seed is P1 in games 1 and 3.</li>
              <li>
                The lower seed can veto one rolled matchup, in any game of the series.
              </li>
            </ul>
          </li>
          <li>
            Super Bowl P1 is the higher seed.
            <ul>
              <li>If both seeds are the same, the better record gets it.</li>
              <li>If the records are the same, coin toss.</li>
            </ul>
          </li>
          <li>
            A bracket is either fixed or reseeded, chosen when it is built. A reseeded
            bracket redraws after each round: highest remaining seed plays lowest remaining.
          </li>
        </ul>
      </Card>

      <Card title="In game">
        <ul className="rules-list">
          <li>CC is allowed.</li>
          <li>
            Games do not end in a tie. Play until there is a winner.
            <ul>
              <li>Alternate kickoffs after the first overtime.</li>
              <li>Load tapmeter for the second overtime.</li>
            </ul>
          </li>
          <li>
            FastEd rule: if anyone quits a game before it ends without the other person’s
            permission, it is automatic +7 for the winner on the final score.
          </li>
        </ul>
      </Card>
    </div>
  )
}
